export const numFormat = (num: number): string => num.toLocaleString();